import { useCallback, useMemo } from 'react';
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const authHeaders = () => ({ Authorization: getAccessTokenApi() });

const useTenantComponentCatalogApi = () => {
  const list = useCallback(async () => {
    const { data } = await axios.get(`${API_PATH}/component-attribute-defs`, {
      headers: authHeaders(),
    });
    return data;
  }, []);

  const listRoots = useCallback(async () => {
    const { data } = await axios.get(`${API_PATH}/component-templates`, {
      headers: authHeaders(),
    });
    return data;
  }, []);

  // Tipos de componente — globales (liftlogic), accesibles por tenants en read-only.
  const listTypes = useCallback(async () => {
    const { data } = await axios.get(`${API_PATH}/component-types`, {
      headers: authHeaders(),
    });
    return data; // { types: [...] }
  }, []);

  return useMemo(() => ({ list, listRoots, listTypes }), [list, listRoots, listTypes]);
};

export default useTenantComponentCatalogApi;
